<template>
  <v-dialog v-model="dialog" persistent width="900">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-icon>visibility</v-icon> Documento adjunto
        <v-spacer></v-spacer>
        <v-btn flat icon title="Ver en otra ventana" @click="openNewWindow()">
          <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <embed
              :src="api_backend[0] + documento.ruta_archivo"
              type="application/pdf"
              v-if="tipo_documento === 'pdf'"
              width="100%"
              height="700px"
            />
            <img
              :src="api_backend[0] + documento.ruta_archivo"
              v-if="
                tipo_documento === 'jpg' ||
                  tipo_documento === 'png' ||
                  tipo_documento === 'jpeg'
              "
              width="100%"
            />
            <embed
              :src="api_backend[0] + documento.ruta_archivo"
              type="application/pdf"
              width="100%"
              height="700px"
              v-if="tipo_documento === 'docx' || tipo_documento === 'doc'"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
/*
   <embed :src="api_backend[0]+documento" type="application/pdf" v-if="tipo_documento === 'pdf'" width="100%" height="700px">
			<img :src="api_backend[0]+documento" width="100%" v-if="tipo_documento=== 'jpg' || tipo_documento=== 'png'  || tipo_documento=== 'jpeg'">  
			 <embed :src="api_backend[0]+documento" type="application/pdf" width="100%" height="700px"  v-if="tipo_documento=== 'docx' || tipo_documento=== 'doc'">
*/

export default {
  // Variables iniciales
  data() {
    return {
      dialog: false,
      loading: false,
      item: null,
      documento: {
        ruta_archivo: ""
      },
      tipo_documento: "",
      api_backend: ""
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerDocumento", item => {
      this.documento = item;
      this.tipo_documento = this.obtenerTipo(this.documento.ruta_archivo);
      this.api_backend = process.env.API_URL.split("api/");
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.loading = false;
      this.dialog = false;
    },
    openNewWindow() {
      window.open(this.api_backend[0] + this.documento.ruta_archivo);
    },
    obtenerTipo(url) {
      const archivo = url.split(".");
      return archivo[1];
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/VerDocumento.vue